import React, { useState } from 'react';
import styles from './styles.module.scss';
import {
    Box,
    Button,
    Typography,
    Link,
} from '@mui/material';
import RequestMoreTimeModal from './components/RequestMoreTimeModal';
import UpgradePlanModal from './components/UpgradePlanModal';
import { useUserSubscription } from './queries/useSubscription';
import { AnimatePresence, motion } from 'framer-motion';
import DecorativeCircles from './components/DecorativeCircles';

const MotionBox = motion(Box);
const TRIAL_DURATION_DAYS = 14;

const getDaysLeft = ({ duration, startDate }) => {
    if (!duration || !startDate) return;
    const activateDate = new Date(startDate);

    const now = new Date();
    const diff = Math.floor((now.getTime() - activateDate.getTime()) / (1000 * 60 * 60 * 24));
    return Math.max(duration - diff, 0);
};

const TrialBanner = () => {
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    const { data: userSubscription, isLoading, isError} = useUserSubscription();
    const isTrial = userSubscription?.subscription_type === 'Trial';
    const effectiveDuration = isTrial ? TRIAL_DURATION_DAYS : userSubscription?.duration;
    const daysLeft = getDaysLeft({ duration: effectiveDuration, startDate: userSubscription?.start_date });

    if(isLoading || isError) return null;

    return (
        <>
            <AnimatePresence>
                <MotionBox
                    key="banner"
                    initial={{ height: 0, minHeight: 0, maxHeight: 0, opacity: 0.5 }}
                    animate={{ height: '42px', minHeight: '42px', maxHeight: '42px', opacity: 1 }}
                    exit={{ height: 0, minHeight: 0, maxHeight: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className={styles.banner}
                >
                    <DecorativeCircles />
                        <MotionBox
                            key="banner-button"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.5, delay: 0.5 }}
                            className={styles.content}
                        >
                            <Box className={styles.left}>
                                <Typography
                                    className={styles.trialText}
                                    component={Link}
                                    href="/#price"
                                    target="_blank"
                                    underline="none"
                                >
                                    Only {daysLeft} days left in your {isTrial ? 'trial' : 'plan'}!
                                </Typography>
                            </Box>

                            <Box className={styles.right}>
                                {daysLeft > 0 ? (
                                    <Button
                                        variant="contained"
                                        className={styles.requestButton}
                                        onClick={() => setShowRequestModal(true)}
                                    >
                                        Request More Time
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        className={styles.upgradeButton}
                                        onClick={() => setShowUpgradeModal(true)}
                                    >
                                        Upgrade Your Plan
                                    </Button>
                                )}
                            </Box>
                        </MotionBox>
                </MotionBox>
            </AnimatePresence>
            <RequestMoreTimeModal open={showRequestModal} onClose={() => setShowRequestModal(false)} />
            <UpgradePlanModal open={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />
        </>
    );
};

export default TrialBanner;
